import { setFilter } from "../tradeByBrokersUXSlice";
import { setData } from "../tradeByBrokersDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import React from "react";
import { TurnoverByBrokersReportFilter } from "../types";
import { useCopiedState } from "../../../../../core/util/hooks";

export const useTradeByBrokersReportFilter = () => {
  const storeFilter = useSelector<StoreType, TurnoverByBrokersReportFilter>(
    (store) => store.ux.reports.exchbusiness.tradeByBrokers.filter
  );
  const [filter, editFilter] = useCopiedState<TurnoverByBrokersReportFilter>(
    storeFilter
  );

  const dispatch = useDispatch();
  const dispatchSetFilter = React.useCallback(() => {
    dispatch(setFilter(filter!));
    dispatch(setData());
  }, [dispatch, filter]);

  return [filter, editFilter, dispatchSetFilter] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter
  ];
};
